import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "../stores/auth";

import HomeView from "../views/HomeView.vue";
import LoginView from "../views/LoginView.vue";
import RegisterView from "../views/RegisterView.vue";
import ForgotPasswordView from "../views/ForgotPasswordView.vue";
import ResetPasswordView from "../views/ResetPasswordView.vue";
import PricingView from "../views/PricingView.vue";
import DashboardView from "../views/DashboardView.vue";
import GamesView from "../views/GamesView.vue";
import SubscriptionView from "../views/SubscriptionView.vue";
import SubscriptionSuccessView from "../views/SubscriptionSuccessView.vue";
import AnalyzeView from "../views/AnalyzeView.vue";
import MatchRecorderView from '../views/MatchRecorderView.vue'
import DiceLabelingTool from "../components/DiceLabelingTool.vue";
import TrainingUploadView from "../views/training/TrainingUploadView.vue";

// Admin views
import AdminDashboardView from "../views/admin/AdminDashboardView.vue";
import AdminUsersView from "../views/admin/AdminUsersView.vue";
import AdminSubscriptionsView from "../views/admin/AdminSubscriptionsView.vue";
import AdminSettingsView from "../views/admin/AdminSettingsView.vue";
import AdminTrainingView from "../views/admin/AdminTrainingView.vue";
import AdminKanbanView from "../views/admin/AdminKanbanView.vue";
import AdminAnalysisView from "../views/admin/AdminAnalysisView.vue";
import PipReviewView from "../views/admin/PipReviewView.vue"
import GameReconstructionView from "../views/admin/GameReconstructionView.vue"

const routes = [
  { path: "/", name: "home", component: HomeView },
  { path: "/login", name: "login", component: LoginView, meta: { guest: true } },
  { path: "/register", name: "register", component: RegisterView, meta: { guest: true } },
  { path: "/forgot-password", name: "forgot-password", component: ForgotPasswordView, meta: { guest: true } },
  { path: "/reset-password", name: "reset-password", component: ResetPasswordView, meta: { guest: true } },
  { path: "/pricing", name: "pricing", component: PricingView },
  { path: "/dashboard", name: "dashboard", component: DashboardView, meta: { auth: true } },
  { path: "/games", name: "games", component: GamesView, meta: { auth: true } },
  { path: "/subscription", name: "subscription", component: SubscriptionView, meta: { auth: true } },
  { path: "/subscription/success", name: "subscription-success", component: SubscriptionSuccessView, meta: { auth: true } },
  { path: "/training/upload", name: "training-upload", component: TrainingUploadView, meta: { auth: true } },

  // Admin routes
  { path: "/admin", name: "admin", component: AdminDashboardView, meta: { auth: true, admin: true } },
  { path: "/admin/users", name: "admin-users", component: AdminUsersView, meta: { auth: true, admin: true } },
  { path: "/admin/subscriptions", name: "admin-subscriptions", component: AdminSubscriptionsView, meta: { auth: true, admin: true } },
  { path: "/admin/settings", name: "admin-settings", component: AdminSettingsView, meta: { auth: true, admin: true } },
  { path: "/admin/training", name: "admin-training", component: AdminTrainingView, meta: { auth: true, admin: true } },
  { path: "/admin/kanban", name: "admin-kanban", component: AdminKanbanView, meta: { auth: true, admin: true } },
  { path: "/admin/analysis", name: "admin-analysis", component: AdminAnalysisView, meta: { auth: true, admin: true } },
  { path: "/admin/analysis/:jobId/review", name: "admin-analysis-review", component: PipReviewView, meta: { auth: true, admin: true } },
  // analyze route
  { path: "/analyze", name: "analyze", component: AnalyzeView, meta: { auth: true } },
  { path: '/recorder', name: 'recorder', component: MatchRecorderView, meta: { auth: true } },
  { path: '/recorder/:matchId', name: 'recorder-match', component: MatchRecorderView, meta: { auth: true } },
  { path: '/admin/games/reconstruction', name: 'admin-games-reconstruction', component: GameReconstructionView, meta: { auth: true, admin: true } },
  {
  path: '/training/dice',
    name: 'dice-labeling',
    component: DiceLabelingTool,
    beforeEnter: (to, from, next) => {
      const auth = useAuthStore();
      if (auth.user?.isAdmin || auth.user?.isModerator) {
        next();
      } else {
        next('/');
      }
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();

  // Initialize auth on first navigation
  if (!auth.user && localStorage.getItem("accessToken")) {
    await auth.init();
  }

  if (to.meta.auth && !auth.isAuthenticated) {
    return { name: "login", query: { redirect: to.fullPath } };
  }

  if (to.meta.guest && auth.isAuthenticated) {
    return { name: "dashboard" };
  }

  // Admin guard
  if (to.meta.admin) {
    const isAdmin = auth.user?.isAdmin === true || auth.user?.isAdmin === 1;
    if (!isAdmin) {
      return { name: "dashboard" };
    }
  }
});

export default router;